import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";
import StatsRule from "../../../common/stats-rule";

export default class ContinuedStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Continue &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const fumbleFragment =
            play.getPreviousFragmentOfState(fragment, FootballState.Fumble) ||
            play.getPreviousFragmentOfState(
                fragment,
                FootballState.FumbledSnapLost
            );

        const startingPossession = play.getContextSnapshot().isHomePossession()
            ? gameContext.homeTeamId
            : gameContext.awayTeamId;

        const distance = gameContext.calculateDistance(fragment.continuedTo);
        const player = fragment.continuedBy;

        const resultedInTd =
            (gameContext.isVisitorPossession() && fragment.continuedTo <= 0) ||
            (gameContext.isHomePossession() &&
                fragment.continuedTo >= gameContext.getFieldLength());

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            playerId: player.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.CONTINUED,
            values: {
                yards: distance,
                completed: 1,
                from: fumbleFragment ? FootballStatsCategory.FUMBLE : null,
                offensive: startingPossession === player.teamId,
                touchdowns: resultedInTd ? 1 : 0
            }
        });
    }
}
